module.exports = __webpack_public_path__ + "media/a8.bdc80e01.wav";